// Exception reporting
export const BUGSNAG = 'f38f920c0646f792f006301974020325';

// Analytics
export const AMPLITUDE_PRODUCTION = '28916b6cd60c79c0447b3c23ad698c98';
export const AMPLITUDE_DEVELOPMENT = '9956c29ab0f3f042369ed79484581c28';
